// users.reducers.ts
import { UsersAction } from '../constants';
import { initialUsersState, IUsersState } from '../state/users.state';

export const usersReducer = (
    state = initialUsersState,
    action: any,
): IUsersState => {
    switch (action.type) {
        case UsersAction.GetUsersSuccess: {
            return {
                ...state,
                users: action.data || [],
            };
        }

        case UsersAction.GetSingleUserSuccess: {
            return {
                ...state,
                selectedUser: action.data,
            };
        }

        case UsersAction.PostUserSuccess: {
            return {
                ...state,
                users: [...state.users, action.data],
            };
        }

        case UsersAction.EditUserSuccess: {
            const updatedUsers = Array.isArray(state.users)
                ? state.users.map(user => {
                    if (user.id === action.data.id) {
                        return action.data;
                    }
                    return user;
                })
                : [];
            
            return {
                ...state,
                users: updatedUsers,
                selectedUser: action.data
            };
        }

        case UsersAction.DeleteUserSuccess: {
            return {
                ...state,
                users: state.users.filter(user => user.id !== action.userId)
            };
        }

        case UsersAction.SyncUsersSuccess: {
            return {
                ...state,
                users: action.data || [],
            };
        }

        default:
            return state;
    }
};